(() => {
  const PROFILE_CLASS = 'elmivra-loose-profile-page';

  const normalizeBuilderLink = (anchor, index) => {
    if (!anchor || !anchor.getAttribute('href')) return;
    let url;
    try {
      url = new URL(anchor.getAttribute('href'), window.location.origin);
    } catch (e) {
      return;
    }
    if (!url.pathname.includes('/pages/build-your-ring')) return;

    url.searchParams.delete('step');
    url.searchParams.set('source', 'loose-diamond');

    const looseHandle = url.searchParams.get('loose_diamond') || url.searchParams.get('source_handle');
    if (looseHandle) url.searchParams.set('source_handle', looseHandle);

    if (!url.searchParams.get('quality')) {
      url.searchParams.set('quality', 'premium');
    }

    if (url.searchParams.get('actual_carat') && !url.searchParams.get('carat')) {
      url.searchParams.set('carat', url.searchParams.get('actual_carat'));
    }

    anchor.setAttribute('href', `${url.pathname}?${url.searchParams.toString()}`);

    if (index === 0) {
      anchor.textContent = 'Build a Ring with This Diamond Profile';
      anchor.setAttribute('aria-label', 'Build a ring with this diamond profile');
    } else {
      anchor.textContent = 'Explore Ring Settings';
      anchor.setAttribute('aria-label', 'Explore ring settings');
    }
  };

  const ensureNotice = (root, actions) => {
    if (!root || !actions || root.querySelector('[data-elmivra-loose-profile-notice]')) return;

    const notice = document.createElement('div');
    notice.className = 'elmivra-loose-profile-planning-note';
    notice.setAttribute('data-elmivra-loose-profile-notice', '');
    notice.innerHTML = `
      <strong>Diamond profile for custom ring planning</strong>
      <span>Final ring pricing is calculated after choosing a setting, metal, diamond quality, ring size, and engraving options.</span>
    `;
    actions.parentNode.insertBefore(notice, actions);
  };

  const applyLooseProfileMode = () => {
    const root = document.querySelector('[id^="MainProduct-"]');
    if (!root) return;

    const actions = root.querySelector('.elmivra-diamond-actions');
    const hasLooseFacts = root.querySelector('.elmivra-diamond-facts');
    if (!actions || !hasLooseFacts) return;

    root.classList.add(PROFILE_CLASS);

    root.querySelectorAll('.elmivra-diamond-action-btn[href*="/pages/build-your-ring"]').forEach(normalizeBuilderLink);

    const note = root.querySelector('.elmivra-diamond-action-note');
    if (note) {
      note.textContent = 'Use this diamond profile as a starting point, then choose an Elmivra ring setting and customize the final details on the product page.';
    }

    ensureNotice(root, actions);

    root.querySelectorAll('.elmivra-loose-buy-direct').forEach(el => {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    });

    root.querySelectorAll('.elmivra-loose-custom-only-notice span').forEach(el => {
      el.textContent = 'This listing is prepared as a custom-ring starting point. Matched IGI certificate details are reviewed before custom production where applicable.';
    });
  };

  const injectStyles = () => {
    if (document.getElementById('elmivra-loose-profile-style')) return;
    const style = document.createElement('style');
    style.id = 'elmivra-loose-profile-style';
    style.textContent = `
      .${PROFILE_CLASS} .price,
      .${PROFILE_CLASS} .product__tax,
      .${PROFILE_CLASS} .product-form__quantity,
      .${PROFILE_CLASS} variant-selects,
      .${PROFILE_CLASS} product-form,
      .${PROFILE_CLASS} .product-form,
      .${PROFILE_CLASS} .shopify-payment-button,
      .${PROFILE_CLASS} pickup-availability,
      .${PROFILE_CLASS} .product__inventory {
        display: none !important;
      }

      .elmivra-loose-profile-planning-note {
        display: grid;
        gap: .45rem;
        margin: 1.3rem 0 1.2rem;
        padding: 1.35rem 1.55rem;
        border-radius: 1.45rem;
        border: 1px solid rgba(168,130,79,.22);
        background: linear-gradient(135deg, rgba(250,247,242,.98), rgba(255,255,255,.98));
        color: #1f1d1a;
      }

      .elmivra-loose-profile-planning-note strong {
        font-size: 1.38rem;
        line-height: 1.35;
      }

      .elmivra-loose-profile-planning-note span {
        font-size: 1.22rem;
        line-height: 1.55;
        color: rgba(31,29,26,.66);
      }

      @media screen and (max-width: 749px) {
        .elmivra-loose-profile-planning-note {
          margin-top: 1rem;
          padding: 1.25rem 1.35rem;
        }
      }
    `;
    document.head.appendChild(style);
  };

  injectStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLooseProfileMode);
  } else {
    applyLooseProfileMode();
  }

  document.addEventListener('shopify:section:load', applyLooseProfileMode);
})();
